// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* apply a natural box layout model to all elements, but allowing components to change */
html {
  box-sizing: border-box;
}

*, *:before, *:after {
  box-sizing: inherit;
}

body {
  font-family: "Open Sans", sans-serif;
  color: #4e555f;
  font-size: 14px;
}

@brand-primary : #50bced;
@brand-secondary : #f37167;
a {
  color: #50bced;
}

.activity-feed {
  padding: 15px;
  list-style: none;
}
.activity-feed .feed-item {
  position: relative;
  padding-bottom: 20px;
  padding-left: 30px;
  border-left: 2px solid #e4e8eb;
}
.activity-feed .feed-item:last-child {
  border-color: transparent;
}
.activity-feed .feed-item::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: -6px;
  width: 10px;
  height: 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #f37167;
}
.activity-feed .feed-item .date {
  display: block;
  position: relative;
  top: -5px;
  color: #8c96a3;
  text-transform: uppercase;
  font-size: 13px;
}
.activity-feed .feed-item .text {
  position: relative;
  top: -3px;
}

.wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 100px);
}

/* this declares a better box model */
* {
  box-sizing: border-box;
}

.list-wrap label {
  float: left;
  color: #00BDE8;
}

.search-box {
  float: left;
  clear: left;
  width: 70%;
  padding: 0.4em;
  font-size: 1em;
  color: #555;
}

.list-count {
  float: left;
  text-align: center;
  width: 30%;
  padding: 0.5em;
  color: #ddd;
}

li {
  transition-property: margin, background-color, border-color;
  transition-duration: 0.4s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out, ease, ease;
}

.empty-item {
  transition-property: opacity;
  transition-duration: 0s;
  transition-delay: 0s;
  transition-timing-function: ease;
}

.empty .empty-item {
  transition-property: opacity;
  transition-duration: 0.2s;
  transition-delay: 0.3s;
  transition-timing-function: ease;
}

.hiding {
  margin-left: -100%;
  opacity: 0.5;
}

.hidden {
  display: none;
}

ul {
  float: left;
  width: 100%;
  margin: 2em 0;
  padding: 0;
  position: relative;
}

ul:before {
  position: absolute;
  left: -2.8em;
  font-size: 3em;
  text-align: right;
  top: 1.5em;
  color: #ededed;
  font-weight: bold;
  font-family: "Maven Pro", sans-serif;
  transform: rotate(-90deg);
}

li {
  float: left;
  clear: left;
  width: 100%;
  margin: 0.2em 0;
  padding: 0.5em 0.8em;
  list-style: none;
  background-color: #f2f2f2;
  border-left: 5px solid #003842;
  cursor: pointer;
  color: #333;
  position: relative;
  z-index: 2;
}

li:hover {
  background-color: #f9f9f9;
  border-color: #00BDE8;
}

.empty-item {
  background: #fff;
  color: #ddd;
  margin: 0.2em 0;
  padding: 0.5em 0.8em;
  font-style: italic;
  border: none;
  text-align: center;
  visibility: hidden;
  opacity: 0;
  float: left;
  clear: left;
  width: 100%;
}

.empty .empty-item {
  opacity: 1;
  visibility: visible;
}

/*
The following are styles purely for the surroundings
*/
body {
  background-color: #fff;
  font-family: "Open Sans", sans-serif;
  margin: 0;
  padding: 0;
  font-size: 1em;
}

a {
  color: #00BDE8;
}

h1 {
  font-size: 2.6em;
  margin: 0;
  padding-top: 1.5em;
  text-align: center;
  font-family: "Maven Pro", sans-serif;
}

.info {
  float: left;
  width: 60%;
  margin: 2em 20%;
  padding: 2em 0;
  background: #f9f9f9;
  border-left: 5px solid #003842;
  padding: 10px 20px;
}

.list-wrap {
  float: left;
  width: 100%;
  margin-right: 10%;
}

p {
  text-align: left;
  font-size: 1em;
}

.cta {
  float: left;
  width: 100%;
  text-align: center;
  color: #999;
  margin: 2em 0;
}

.cta a {
  font-size: 1.5em;
  font-style: normal;
  text-decoration: none;
  line-height: 1.5em;
}

.topdeco {
  float: left;
  width: 100%;
  height: 10px;
  position: fixed;
  z-index: 10;
}

.topdeco span {
  float: left;
  width: 25%;
  height: 100%;
}

.deco span:nth-child(1) {
  background: #FF8220;
}

.deco span:nth-child(2) {
  background: #000;
}

.deco span:nth-child(3) {
  background: #FFA00A;
}

.deco span:nth-child(4) {
  background: #00BDE8;
}

#container1 {
  margin-top: 10%;
  float: left;
  width: 100%;
  max-height: 500px;
}

#col2 {
  float: left;
  width: 100%;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 50px;
}

::-webkit-scrollbar-thumb {
  background: #fd7e14;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #b30000;
}

.in {
  position: relative;
}

.item-in {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 5px;
}

/*
tasks list
*/
.tasks-list {
  height: 450px;
  overflow: auto;
}

::ng-deep .mat-mdc-text-field-wrapper {
  background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+tasks/see-tasks/see-tasks.component.scss"],"names":[],"mappings":"AAAA,wFAAA;AACA;EACE,sBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AAGA;EACE,oCAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAIA,wBAAA;AACA,0BAAA;AAEA;EACE,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,gBAAA;AAFF;AAIE;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;AAFJ;AAII;EACE,yBAAA;AAFN;AAKI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAHN;AAMI;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;AAJN;AAMI;EACE,kBAAA;EACA,SAAA;AAJN;;AASA;EACE,aAAA;EACA,qCAAA;EACA,oCAAA;AANF;;AASA,qCAAA;AACA;EAGE,sBAAA;AANF;;AASA;EACE,WAAA;EACA,cAAA;AANF;;AASA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;AANF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;AANF;;AASA;EACE,2DAAA;EACA,qCAAA;EACA,mDAAA;AANF;;AASA;EACE,4BAAA;EACA,uBAAA;EACA,oBAAA;EACA,gCAAA;AANF;;AASA;EACE,4BAAA;EACA,yBAAA;EACA,sBAAA;EACA,gCAAA;AANF;;AASA;EACE,kBAAA;EACA,YAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;AANF;;AASA;EAEE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;AAPF;;AAUA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAPF;;AAUA;EACE,yBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AAPF;;AAUA;EACE,UAAA;EACA,mBAAA;AAPF;;AAUA;;CAAA;AAIA;EACE,sBAAA;EACA,oCAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;AARF;;AAWA;EACE,WAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AARF;;AAWA;EACE,WAAA;EACA,WAAA;EACA,iBAAA;AARF;;AAYA;EACE,gBAAA;EACA,cAAA;AATF;;AAYA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EAEA,aAAA;AAVF;;AAaA;EACE,gBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAXF;;AAcA;EACE,WAAA;EACA,UAAA;EACA,YAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;AAXF;;AAcA;EACE,WAAA;EACA,WAAA;AAXF;;AAeA;EACE,UAAA;AAZF;;AAeA;EACE,8BAAA;EACA,mBAAA;AAZF;;AAeA;EACE,mBAAA;EACA,mBAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EAEE,kBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;AAbF;;AAgBA;;CAAA;AAGA;EAEE,aAAA;EACA,cAAA;AAdF;;AAgBA;EACE,kCAAA;AAbF","sourcesContent":["/* apply a natural box layout model to all elements, but allowing components to change */\r\nhtml {\r\n  box-sizing: border-box;\r\n}\r\n\r\n*, *:before, *:after {\r\n  box-sizing: inherit;\r\n}\r\n\r\n@import url(https://fonts.googleapis.com/css?family=Open+Sans);\r\n\r\nbody {\r\n  font-family: 'Open Sans', sans-serif;\r\n  color: #4e555f;\r\n  font-size: 14px;\r\n}\r\n\r\n// Colors:\r\n@brand-primary : #50bced; // Blue\r\n@brand-secondary : #f37167; // Orange\r\n\r\na {\r\n  color: #50bced;\r\n}\r\n\r\n.activity-feed {\r\n  padding: 15px;\r\n  list-style: none;\r\n\r\n  .feed-item {\r\n    position: relative;\r\n    padding-bottom: 20px;\r\n    padding-left: 30px;\r\n    border-left: 2px solid #e4e8eb;\r\n\r\n    &:last-child {\r\n      border-color: transparent;\r\n    }\r\n\r\n    &::after {\r\n      content: \"\";\r\n      display: block;\r\n      position: absolute;\r\n      top: 0;\r\n      left: -6px;\r\n      width: 10px;\r\n      height: 10px;\r\n      border-radius: 6px;\r\n      background: #fff;\r\n      border: 1px solid #f37167;\r\n    }\r\n\r\n    .date {\r\n      display: block;\r\n      position: relative;\r\n      top: -5px;\r\n      color: #8c96a3;\r\n      text-transform: uppercase;\r\n      font-size: 13px;\r\n    }\r\n    .text {\r\n      position: relative;\r\n      top: -3px;\r\n    }\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  grid-template-rows: repeat(3, 100px);\r\n}\r\n\r\n/* this declares a better box model */\r\n* {\r\n  -moz-box-sizing: border-box;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.list-wrap label {\r\n  float: left;\r\n  color: #00BDE8;\r\n}\r\n\r\n.search-box {\r\n  float: left;\r\n  clear: left;\r\n  width: 70%;\r\n  padding: 0.4em;\r\n  font-size: 1em;\r\n  color: #555;\r\n}\r\n\r\n.list-count {\r\n  float: left;\r\n  text-align: center;\r\n  width: 30%;\r\n  padding: 0.5em;\r\n  color: #ddd;\r\n}\r\n\r\nli {\r\n  transition-property: margin, background-color, border-color;\r\n  transition-duration: .4s, .2s, .2s;\r\n  transition-timing-function: ease-in-out, ease, ease;\r\n}\r\n\r\n.empty-item {\r\n  transition-property: opacity;\r\n  transition-duration: 0s;\r\n  transition-delay: 0s;\r\n  transition-timing-function: ease;\r\n}\r\n\r\n.empty .empty-item {\r\n  transition-property: opacity;\r\n  transition-duration: .2s;\r\n  transition-delay: .3s;\r\n  transition-timing-function: ease;\r\n}\r\n\r\n.hiding {\r\n  margin-left: -100%;\r\n  opacity: 0.5;\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\nul {\r\n  float: left;\r\n  width: 100%;\r\n  margin: 2em 0;\r\n  padding: 0;\r\n  position: relative;\r\n}\r\n\r\nul:before {\r\n\r\n  position: absolute;\r\n  left: -2.8em;\r\n  font-size: 3em;\r\n  text-align: right;\r\n  top: 1.5em;\r\n  color: #ededed;\r\n  font-weight: bold;\r\n  font-family: 'Maven Pro', sans-serif;\r\n  transform: rotate(-90deg);\r\n}\r\n\r\nli {\r\n  float: left;\r\n  clear: left;\r\n  width: 100%;\r\n  margin: 0.2em 0;\r\n  padding: 0.5em 0.8em;\r\n  list-style: none;\r\n  background-color: #f2f2f2;\r\n  border-left: 5px solid #003842;\r\n  cursor: pointer;\r\n  color: #333;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\nli:hover {\r\n  background-color: #f9f9f9;\r\n  border-color: #00BDE8;\r\n}\r\n\r\n.empty-item {\r\n  background: #fff;\r\n  color: #ddd;\r\n  margin: 0.2em 0;\r\n  padding: 0.5em 0.8em;\r\n  font-style: italic;\r\n  border: none;\r\n  text-align: center;\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  float: left;\r\n  clear: left;\r\n  width: 100%;\r\n}\r\n\r\n.empty .empty-item {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n/*\r\nThe following are styles purely for the surroundings\r\n*/\r\n\r\nbody {\r\n  background-color: #fff;\r\n  font-family: 'Open Sans', sans-serif;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 1em;\r\n}\r\n\r\na {\r\n  color: #00BDE8;\r\n}\r\n\r\nh1 {\r\n  font-size: 2.6em;\r\n  margin: 0;\r\n  padding-top: 1.5em;\r\n  text-align: center;\r\n  font-family: 'Maven Pro', sans-serif;\r\n}\r\n\r\n.info {\r\n  float: left;\r\n  width: 60%;\r\n  margin: 2em 20%;\r\n  padding: 2em 0;\r\n  background: #f9f9f9;\r\n  border-left: 5px solid #003842;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.list-wrap {\r\n  float: left;\r\n  width: 100%;\r\n  margin-right: 10%;\r\n\r\n}\r\n\r\np {\r\n  text-align: left;\r\n  font-size: 1em;\r\n}\r\n\r\n.cta {\r\n  float: left;\r\n  width: 100%;\r\n  text-align: center;\r\n  color: #999;\r\n\r\n  margin: 2em 0;\r\n}\r\n\r\n.cta a {\r\n  font-size: 1.5em;\r\n  font-style: normal;\r\n\r\n  text-decoration: none;\r\n  line-height: 1.5em;\r\n}\r\n\r\n.topdeco {\r\n  float: left;\r\n  width: 100%;\r\n  height: 10px;\r\n  position: fixed;\r\n  z-index: 10;\r\n}\r\n\r\n.topdeco span {\r\n  float: left;\r\n  width: 25%;\r\n  height: 100%;\r\n}\r\n\r\n.deco span:nth-child(1) {\r\n  background: #FF8220;\r\n}\r\n\r\n.deco span:nth-child(2) {\r\n  background: #000;\r\n}\r\n\r\n.deco span:nth-child(3) {\r\n  background: #FFA00A;\r\n}\r\n\r\n.deco span:nth-child(4) {\r\n  background: #00BDE8;\r\n}\r\n\r\n#container1 {\r\n  margin-top: 10%;\r\n  float: left;\r\n  width: 100%;\r\n  max-height: 500px;\r\n}\r\n\r\n#col2 {\r\n  float: left;\r\n  width: 100%;\r\n\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 5px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 5px grey;\r\n  border-radius: 50px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #fd7e14;\r\n  border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #b30000;\r\n}\r\n\r\n.in {\r\n\r\n  position: relative;\r\n}\r\n\r\n.item-in {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  margin-right: 5px;\r\n}\r\n\r\n/*\r\ntasks list\r\n*/\r\n.tasks-list {\r\n\r\n  height: 450px;\r\n  overflow: auto;\r\n}\r\n::ng-deep .mat-mdc-text-field-wrapper {\r\n  background-color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
